module.exports = __webpack_public_path__ + "05c8d71ab32dbedca0e49f0b6423db42.svg";